import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import BasePage from '../../baseClasses/BasePage';
import _ from 'lodash';

import LocationsService from '../../services/locationsService';
import dataModel from '../../models/DataModel';
import mobileBridge from '../../helpers/MobileBridge';
import { mobile_project_root } from '../../dao/ProjectsDAO';
import PageStateDAO from '../../dao/PageStateDAO';
import { PageNames } from '../../constants/ReduxConstants';
import ModalBannerConstants from '../../constants/ModalBannerConstants';
import AnnouncementWalkthroughSettings from '../../constants/AnnouncementWalkthroughSettings';
import AnalyticsLogger from '../../helpers/analytics/analyticsLogger';

import MobileHeader from '../../components/MobileHeader';
import ProjectDetailsHeader from '../../components/ProjectDetailsHeader';
import { ProjectDetailsContainer } from '../../containers/ProjectDetailsContainer';
import MobileMyTasks from '../../containers/ProjectDetailsContainer/MobileMyTasks/index';
import TabbedPageControl from '../../components/TabbedPageControl';
import DelaysContainer from '../../components/DelaysContainer';
import CollectionDataSource from '../../dao/DataSource/CollectionDataSource';
import DataSource from '../../dao/DataSource/DataSource';
import MobileSelectProjectMember from '../../containers/ProjectsContainer/ProjectCRUD/MobileSelectProjectMember';

import OfflineCloudDoubleIcon from '../../assets/images/offline-cloud-double-slash.svg';

import '../MobileWrapper.scss';
import './ProjectDetailsWrapper.scss';

const shallowTaskDescriptor = {
  task: {
    completion_criteria: {},
  },
};

const shallowProjectDescriptor = {
  project: {
  },
};

/**
 * Wrapper component for mobile project details. 
 * Should only be reached by the following route:
 *   /mobile/projects/{:project_id}
 */
export class ProjectDetailsWrapper extends BasePage {

  constructor(props) {
    super(props);

    const { project, location } = this.props;
 
    if (project && project.name && project.status) {
      this.projectName = project.name;
      this.projectStatus = project.status;
    }
    else if (location) {
      // get basic project info from route change if not on props
      this.projectName = location.state ? location.state.projectName : '';
      this.projectStatus = location.state ? location.state.projectStatus : '';
    }

    const pageName = PageNames.MOBILE_PROJECT_DETAIL;
    const pageState = PageStateDAO.findPageState(pageName);

    this.state = {
      tabSelected: pageState && pageState.tabSelected ? pageState.tabSelected : 'Details',
      fetchedTasks: null,
      offlineNoData: false,
      loadingTasks: true,
      project,
    };
    this.tabs=[];
    if (props.currentUser.role.name=='admin' || props.currentUser.role.name=='editor'){
      this.tabs = ['Details', 'Tasks', 'Members', 'Delays'];
    }else{
      this.tabs = ['Details', 'Tasks', 'Delays'];
    }

    const currentRole = props.currentUser ? props.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({ currentRole, isMobile: !!window.cordova });
    this.createTabContent = this.createTabContent.bind(this);
  }

  handleTasksRetrieval(tasks, action, acData, fetchedData) {
    this.setState({
      tasks: tasks.tasks,
      offlineNoData: false,
      loadingTasks: false,
    });
  }

  handleProjectRetrieval(fetchedProject, action, acData, fetchedData) {
    if (acData && acData.type == 'deleteProject' && this.state.project && acData.project_id == this.state.project.id) {
      this.props.history.goBack();
    }
    else {
      if (fetchedProject) {
        this.setState({ project: fetchedProject });
        const pageName = PageNames.MOBILE_PROJECT_DETAIL;
        const pageState = PageStateDAO.findPageState(pageName);
    
        const routerState = this.props.history.getState();
        if (pageState && pageState.tabSelected == 'Delays') {
          if (routerState && routerState.newDelay) {
            if (!fetchedProject.delays || !fetchedProject.delays.find(delay => { return delay.id == routerState.newDelay.id; })) {
              if (!fetchedProject.delays) {
                fetchedProject.delays = [];
              }
              fetchedProject.delays.unshift(routerState.newDelay);
            }
          }
          if (fetchedProject.delays) {
            fetchedProject.delays.sort((d1, d2) => {
              return d1.id < d2.id ? 1 : -1;
            });
          }
        }
        this.projectName = fetchedProject.name;
        this.projectStatus = fetchedProject.status;
        if (this.locationDataSource) {
          this.locationDataSource.release();
        }
        this.locationDataSource = new DataSource('Location', fetchedProject.location_id, { location: { market: {}, users: {}, location_users: { user: { additionalFields: ['profile_image'] } } } });
        this.locationDataSource.get();
        
        if (this.tasksDataSource) {
          this.tasksDataSource.release();
        }
        this.tasksDataSource = new CollectionDataSource('TasksAssignedByProjectCollection', 'Task', shallowTaskDescriptor, this.handleTasksRetrieval, 'TasksAssigned',
          fetchedProject.id, this.props.currentUser.id, localStorage.current_company_id, null);
        this.tasksDataSource.current();
      }
    }
  }

  componentDidMount() {
    mobileBridge.initialize(this.props.history);
    const {
      project,
      match,
    } = this.props;

    let params = match ? match.params : {};

    // register for speech detection
    dataModel.mobileBridge.addSpeechDetectedObserver(this.handleSpeechDetected);

    if (project) {
      this.tasksDataSource = new CollectionDataSource('TasksAssignedByProjectCollection', 'Task', shallowProjectDescriptor, this.handleTasksRetrieval,
        'TasksAssigned', project.id, this.props.currentUser.id, localStorage.current_company_id);
    } else if (params.project_id) {
      this.fetchProjectAndLocation(params);
    }

    if (this.props.currentUser && (!this.props.currentUser.settings ||
        !this.props.currentUser.settings.user_has__viewed_mobile_delays_announcement_project)) {
      const internalElement = <div className="announcement-highlight">
        DELAYS
      <div className="divider-line"></div>
      </div>;

      let settings = _.cloneDeep(AnnouncementWalkthroughSettings.projectDetailPageDelayAnnouncement);
      settings.highlightSettings.internalElement = internalElement;
      dataModel.showCircleGlobalModal(ModalBannerConstants.DELAYS_ANNOUNCEMENT_CIRCLE_ANNOUNCEMENT, {
        side: 'right-side', userSetting: 'user_has__viewed_mobile_delays_announcement_project', announcementSettings: settings,
      });
    }

  }

  componentWillUnmount() {
    if (this.tasksDataSource) {
      this.tasksDataSource.release();
      this.tasksDataSource = null;
    }
    if (this.projectDataSource) {
      this.projectDataSource.release();
      this.projectDataSource = null;
    }
    dataModel.mobileBridge.removeSpeechDetectedObserver(this.handleSpeechDetected);
  }

  handleSpeechDetected(speechText) {
    const { tasks } = this.state;
    const speechDataLowerWithoutSpaces = speechText.replace(/ /g,'').toLowerCase();
    if (tasks) {
      for (let task of tasks) {
        const taskNameLowerWithoutSpaces = task.name.replace(/ /g,'').toLowerCase();
        if (taskNameLowerWithoutSpaces == speechDataLowerWithoutSpaces) {
          this.props.history.push('/mobile/projects-tasks/task/'+task.id);
          return;
        }
      }
      setTimeout(() => {
        dataModel.showGlobalModal('HANDSFREE_ERROR_MODAL', {
          message: 'Hint: try saying the name of a task',
        });
      }, 2000);
    }
  }

  componentDidUpdate(prevProps) {
    const prevParams = prevProps.match ? prevProps.match.params : {};
    const nextParams = this.props.match ? this.props.match.params : {};
    if (prevParams.project_id != nextParams.project_id ||
      prevProps.navigateUri != this.props.navigateUri) {
      this.fetchProjectAndLocation(this.props.match.params);
    }
  }

  async fetchProjectAndLocation(params, fetchedData) {
    this.setState({ loadingTasks: true });
    let projectDescriptor = { ...mobile_project_root };

    const pageName = PageNames.MOBILE_PROJECT_DETAIL;
    const pageState = PageStateDAO.findPageState(pageName);

    if (pageState && pageState.tabSelected == 'Delays') {
      projectDescriptor.project.delays = {
        attachments: { additionalFields: ['upload', 'photo_longitude', 'photo_latitude', 'photo_taken_at'] },
      };
    }
    if (this.projectDataSource) {
      this.projectDataSource.release();
    }

    this.projectDataSource = new DataSource('Project', +params.project_id, projectDescriptor, this.handleProjectRetrieval);
    this.projectDataSource.get();
  }
  x
  handleRefDocOpen() {
    this.setState({ refDocOpen: true });
  }

  handleCloseRefDoc() {
    this.setState({ refDocOpen: false });
  }

  handleBackButton() {
    if (this.state.refDocOpen) {
      this.handleCloseRefDoc();
      return;
    }
    // go to default tab next time this page is invoked
    PageStateDAO.setPageStateEntry(PageNames.MOBILE_PROJECT_DETAIL, 'tabSelected', null);
    this.props.history.goBack();
  }

  async handleSelectTab(tabView) {
    PageStateDAO.setPageStateEntry(PageNames.MOBILE_PROJECT_DETAIL, 'tabSelected', tabView);
    if (tabView == 'Delays') {
      this.analyticsLogger.logDelayEvent('DelaysTabSelected');
      // Initialize the project for delays (if it already has been, the get will just fetch what is in the store)
      let projectDescriptor = { ...mobile_project_root };
      projectDescriptor.project.delays = {
        attachments: { additionalFields: ['upload', 'photo_longitude', 'photo_latitude', 'photo_taken_at'] },
      };

      if (this.projectDataSource) {
        this.projectDataSource.release();
      }
      this.projectDataSource = new DataSource('Project', this.state.project.id, projectDescriptor, this.handleProjectRetrieval);
      this.projectDataSource.get();
      this.setState({ tabSelected: tabView });
    }
    else {
      this.setState({ tabSelected: tabView });
    }
  }

  createTabContent() {
    const { isOnline } = this.props;
    const { tabSelected, offlineNoData, project } = this.state;

    if (tabSelected == 'Details') {
      if (offlineNoData) {
        return (
          <div className="offline-view">
            <span className="offline-view__text">No Data Available</span>
            <img className="offline-view__cloud-img" src={OfflineCloudDoubleIcon} alt="offline-cloud" />
          </div>
        );
      }
      else if (project && project.name) {
        return (
          <ProjectDetailsContainer
            history={this.props.history}
            project={project}
            online={isOnline}
            actionCableUpdate={this.props.actionCableUpdate}
            handleRefDocOpen={this.handleRefDocOpen}
            refDocOpen={this.state.refDocOpen}
          />
        );
      }
    }
    else if (tabSelected == 'Tasks') {
      return (
        <MobileMyTasks
          project={project}
          online={isOnline}
          tasks={this.state.tasks}
          tasksDAO={this.props.tasksDAO}
          pending={this.state.loadingTasks}
          actionCableUpdate={this.props.actionCableUpdate}
        />
      );
    }
    else if (tabSelected == 'Members') {
      return (
        <MobileSelectProjectMember
          project={project}
          online={isOnline}
          actionCableUpdate={this.props.actionCableUpdate}
        />
      );
    }
    else {
      return (
        <DelaysContainer 
          project={project}
        />
      );
    }
  }

  render() {
    const { project, refDocOpen } = this.state;

    if (!project) {
      return (
        <div className="mobile-wrapper">
          <MobileHeader
            headerTitle={this.textMap.project}
            rootPage={this.props.rootPage}
            useDoneButton={this.state.refDocOpen}
            navigateBack={this.handleBackButton}
            displayHandsFree={true}
          />
        </div>
      );
    }

    const projectForHeader = project || { status: this.projectStatus, name: this.projectName };

    return (
      <div className="mobile-wrapper">
        <MobileHeader
          headerTitle="Project"
          hasOfflineChanges={project ? project._dirty : false}
          hasFilters={false}
          noBackButton={false}
          useDoneButton={refDocOpen}
          navigateBack={this.handleBackButton}
          displayHandsFree={true}
        />
        <div className="content-wrapper">
          <ProjectDetailsHeader project={projectForHeader} status={this.offline_project}/>
          <TabbedPageControl
            tabItems={this.tabs}
            selectedTabName={this.state.tabSelected}
            handleClick={this.handleSelectTab}
          />
          <div className="main-content">
            { this.createTabContent() }
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentUser: state.new_users.currentUser,
    actionCableUpdate: state.main.actionCableUpdate,
    isOnline: state.main.online,
    navigateUri: state.main.navigateUri,
  };
};
export default withRouter(connect(mapStateToProps)(ProjectDetailsWrapper));



// WEBPACK FOOTER //
// ./src/mobileWrappers/ProjectDetailsWrapper/index.js